import type { MatchingLaunchStatus } from "./types";

export type InitialLaunchMemberView = {
  kind: "collecting" | "milestone" | "live";
  title: string;
  body: string;
  showProgress: boolean;
};

export function getInitialLaunchMemberView(status: MatchingLaunchStatus): InitialLaunchMemberView {
  if (status.phase === "live") {
    return {
      kind: "live",
      title: "The first matching rounds are beginning",
      body: "You're ready for matching. We'll let you know as soon as there's a thoughtful introduction for you.",
      showProgress: false,
    };
  }
  if (status.foundingMilestoneReached) {
    return {
      kind: "milestone",
      title: "Yara's founding community is here",
      body: "Your profile is ready. Yara is preparing its first thoughtful introductions, and we'll let you know when it's time.",
      showProgress: true,
    };
  }
  return {
    kind: "collecting",
    title: "Yara is gathering its founding community",
    body: "Your profile is ready for matching. We'll let you know when the first rounds begin.",
    showProgress: true,
  };
}
